import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

const chapters = [
  {
    number: '01',
    icon: 'ri-lightbulb-line',
    title: 'O que é Palestra Silenciosa',
    description: 'Entenda a tecnologia, como o áudio chega ao fone de cada participante e por que isso muda tudo na experiência do evento.',
    pages: 'p. 3-6',
  },
  {
    number: '02',
    icon: 'ri-line-chart-line',
    title: 'Por que seu Evento Precisa Disso',
    description: 'Dados de engajamento, redução de custos e casos de sucesso que mostram o impacto real do formato silencioso.',
    pages: 'p. 7-10',
  },
  {
    number: '03',
    icon: 'ri-check-double-line',
    title: 'Checklist de Planejamento',
    description: 'Passo a passo completo: da definição do número de canais até o suporte no dia do evento. Nada fica de fora.',
    pages: 'p. 11-14',
  },
  {
    number: '04',
    icon: 'ri-stack-line',
    title: 'Formatos e Aplicações',
    description: 'Conferências, treinamentos, eventos multilíngues, silent disco, casamentos — cada formato com suas particularidades.',
    pages: 'p. 15-18',
  },
  {
    number: '05',
    icon: 'ri-tools-line',
    title: 'Fornecedores e Orçamento',
    description: 'O que avaliar ao contratar, perguntas certas para fazer e como comparar propostas sem cair em armadilhas.',
    pages: 'p. 19-22',
  },
];

export default function ChaptersSection() {
  const { ref: headerRef, isVisible: headerVisible } = useScrollAnimation({ threshold: 0.1 });
  const { ref: gridRef, isVisible: gridVisible } = useScrollAnimation({ threshold: 0.05 });

  return (
    <section className="py-20 md:py-32 bg-white">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        {/* Header */}
        <div ref={headerRef} className="text-center mb-16">
          <span className="font-body text-xs font-semibold uppercase tracking-[0.2em] text-primary mb-4 block">
            Conteúdo do Guia
          </span>
          <h2
            className={`font-heading font-bold text-4xl md:text-6xl text-secondary mb-6 transition-all duration-700 ${headerVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
          >
            o que você vai<br />encontrar aqui
          </h2>
          <p
            className={`font-body text-lg text-gray-500 max-w-xl mx-auto transition-all duration-700 delay-150 ${headerVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
          >
            Um roteiro completo em 5 capítulos — do básico ao avançado
          </p>
        </div>

        {/* Grid */}
        <div
          ref={gridRef}
          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6"
        >
          {chapters.map((ch, i) => (
            <div
              key={i}
              className={`group bg-gray-50 border border-gray-100 rounded-2xl p-6 md:p-8 hover:border-primary/20 hover:-translate-y-1 transition-all duration-500 ${gridVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
              style={{ transitionDelay: `${i * 80}ms` }}
            >
              {/* Chapter number */}
              <div className="flex items-center justify-between mb-5">
                <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary/10">
                  <i className={`${ch.icon} text-primary text-xl`} />
                </div>
                <span className="font-body text-xs text-gray-400 font-medium">{ch.pages}</span>
              </div>

              {/* Number badge */}
              <span className="font-heading font-extrabold text-4xl text-primary/15 block mb-3 leading-none">
                {ch.number}
              </span>

              <h3 className="font-heading font-bold text-lg text-secondary mb-2 group-hover:text-primary transition-colors">
                {ch.title}
              </h3>
              <p className="font-body text-sm text-gray-600 leading-relaxed">
                {ch.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}